import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseLoader = _resolveComponent("BaseLoader")!
  const _component_BaseText = _resolveComponent("BaseText")!
  const _component_BaseBlock = _resolveComponent("BaseBlock")!

  return (_openBlock(), _createBlock(_component_BaseBlock, {
    class: _normalizeClass([_ctx.$attrs.class, "m_flex m_flex-column m_gap26 m_align-center"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_BaseLoader, {
        size: 80,
        width: 8,
        variant: "page"
      }),
      _createVNode(_component_BaseText, { class: "m_h4 m_color-accent m_page-loader-text" }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Загрузка... ")
        ])),
        _: 1,
        __: [0]
      })
    ]),
    _: 1
  }, 8, ["class"]))
}